<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="' '+(overlay.name)"
        ref="geoitemsLayer"
        @ready="onReady()"
    >
        <l-feature-group
            ref="geoitemsCluster"
            id="geoitems-cluster"
        ></l-feature-group>
    </l-layer-group>
</template>

<script>
import {LLayerGroup,LFeatureGroup} from "@vue-leaflet/vue-leaflet";
import {mapGetters, mapActions} from "vuex";
import debounce from "lodash/debounce";
import {corridor as LCorridor} from "@/components/app/map/leaflet-corridor";

export default {
    name: "SectionMap_layer_geoitems",
    mixins: [],
    inject: ['L', 'mapLeafletObject'],
    props: {
        modelValue: Object,
    },
    emits: ['update:modelValue'],
    components: {
        LLayerGroup,
        LFeatureGroup,
    },
    data() {
        return {
            geoitemsLayer: null,
            geoitemsCluster: null,

            geoitems: [],
            geoitemsClusterOptions: {
                chunkedLoading: true,
                removeOutsideVisibleBounds: true,
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                zoomToBoundsOnClick: false,
                disableClusteringAtZoom: 5,
                // iconCreateFunction: function(cluster) {
                //     return L.divIcon({ html: '<b>' + cluster.getChildCount() + '</b>' });
                // }
            },
        }
    },
    computed: {
        ...mapGetters([
            "getGeoitemsOnMap",
            "getGeozones",
            "getGeozonesByIds",
            "getGeozonesLOptions",
            "getGeoitemEdit",
        ]),

        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        isShowLayer() {
            return this.overlay?.showLayer
        },
        geoitemActiveId(){
            return this.isShowLayer ? +this.routeFilter.geozoneId : undefined
        },
        geoitemEditId() {
            return this.getGeoitemEdit ?
                +this.getGeoitemEdit?.geoitemId || +this.getGeoitemEdit?.geopointId || +this.getGeoitemEdit?.geozoneId : null;
        },
        activeGezone() {
            return this.getGeozonesByIds[this.geoitemActiveId]
        },
        geoitemsOnMap() {
            if (!this.isShowLayer) return []
            let unitsOnMap = [...this.getGeoitemsOnMap]
            //if (this.geoitemActiveId) unitsOnMap = [this.geoitemActiveId]
            return unitsOnMap//.filter(arrayFilter_OnlyUnique)
        },
    },
    watch: {
        geoitemActiveId: {
            handler: function (newGeo, oldGeo) {
                if(newGeo || oldGeo) {
                    //if(this.$isDevelopment) console.log('getGeoitemActiveId', newGeo, oldGeo)
                }

                let geoitems = this.geoitemsOnMap
                if (newGeo) {
                    geoitems = [newGeo]
                    //ToDo fix
                    this.setMapBoundsByGeozones(geoitems)
                    // let paddingBounds = this.getMapPaddingBounds || this.$consts.components.map.paddingBounds
                    // this.mapLeafletObject.fitBounds(getBounds(), paddingBounds)
                }
                this.setGeoitemsVisible(geoitems)//???
            },
            immediate: true,
        },
        geoitemsOnMap: {
            handler: function (newGeos, oldGeos) {
                if (!oldGeos?.length) {
                    // if(this.$isDevelopment) console.log('getGeoitemsOnMap', newGeos, oldGeos)
                }
                // let added = newGeos.filter(id => !oldGeos.includes(id));
                // let removed = oldGeos.filter(id => !newGeos.includes(id));
                this.setGeoitemsVisible(newGeos)
                if(this.isShowLayer && newGeos?.length) {
                    //ToDo fix
                    this.setMapBoundsByGeozones(newGeos)
                    // let paddingBounds = this.getMapPaddingBounds || this.$consts.components.map.paddingBounds
                    // this.mapLeafletObject.fitBounds(getBounds(), paddingBounds)
                }
            },
            deep: true
        },
        getGeozonesLOptions: {
            handler: function (newGeoLOptions, oldGeoLOptions) {
                if (!newGeoLOptions?.length || !oldGeoLOptions?.length) {
                    //if(this.$isDevelopment) console.log('SectionMap_layer_geoitems.getGeozonesLOptions', newGeoLOptions?.length, oldGeoLOptions?.length)
                }
                this.debouncedUpdateGeozones();
            },
            deep: true
        },
        geoitemEditId: {
            handler: function (newId, oldId) {
                //if(this.$isDevelopment) console.log('geoitemEditId', newId, oldId)
                let geoitems = this.geoitemsOnMap
                if(newId){
                    if(!oldId) this.overlay_visible = false
                } else {
                    this.overlay_visible = true
                    if (this.geoitemActiveId) {
                        geoitems = [this.geoitemActiveId]
                    }
                }
                this.setGeoitemsVisible(geoitems)
                if(this.isShowLayer) {
                    //this.setMapBoundsByGeozones(geoitems)
                }
            },
        },
    },
    methods: {
        ...mapActions([
            "setMapBoundsByGeozones",
        ]),
        setGeoitemsVisible(geoitemsOnMap) {
            this.geoitems.forEach(geo => {
                if (!geo?.options?.geozoneId) return false
                if (this.getGeoitemEdit && this.geoitemEditId === +geo.options.geozoneId  && this.geoitemsLayer.hasLayer(geo)) {
                    //if(this.$isDevelopment) console.log('skip getGeoitemEdit', this.getGeoitemEdit, geo.options)
                    this.geoitemsLayer.removeLayer(geo)
                } else
                if (geoitemsOnMap.includes(geo.options.geozoneId) && !this.geoitemsLayer.hasLayer(geo)) {
                    // if(this.$isDevelopment) console.log('addLayer', geo.options)
                    this.geoitemsLayer.addLayer(geo)
                } else
                if (!geoitemsOnMap.includes(geo.options.geozoneId) && this.geoitemsLayer.hasLayer(geo)) {
                    // if(this.$isDevelopment) console.log('removeLayer', geo.options)
                    this.geoitemsLayer.removeLayer(geo)
                }
            })
        },
        createGeoitem(geoitemLOptions) {
            let geoitem = null
            let options = {...geoitemLOptions}
            //fillColor???
            if (!options.fillOpacity) options.fillOpacity = 0.5
            if (options.type === 'circle') {
                if (options.points && options.points.length == 1 && options.radius) {
                    let center = options.points[0]
                    if(!center?.length && center?.length != 0) {
                        console.error('points null', options)
                    }
                    if (center?.length > 2) center = center.slice(0, 2);
                    geoitem = this.L.circle(center, options.radius, options);
                }
            } else
            if (options.type === 'polygon') {
                if (options.points && options.points.length > 1) {
                    geoitem = this.L.polygon(options.points, options);
                }
            } else
            if (options.type === 'corridor') {
                options.layerType = 'polyline'
                options.polyline_radius = options.radius;
                options.corridor = options.radius / 2;
                if (options.points && options.points.length > 1) {
                    geoitem = LCorridor(options.points, options);
                }
            }
            return geoitem
        },
        updateGeozones() {
            // if(this.$isDevelopment) console.log('updateGeozones', this.geoitems.length, this.getGeozonesLOptions.length)

            //remove geozones
            let ids = this.getGeozonesLOptions.map(go => go.geozoneId)
            this.geoitems.forEach(geo => {
                if (geo.options.geozoneId && !ids.includes(geo.options.geozoneId))
                    this.geoitemsLayer.removeLayer(geo)
            })

            // let geoitems = []
            this.getGeozonesLOptions.forEach(geozoneLOptions => {
                if (this.getGeoitemEdit && this.geoitemEditId == +geozoneLOptions.geozoneId) {
                    //if(this.$isDevelopment) console.log('skip geozone: ', geozoneLOptions.geozoneId, geozoneLOptions)
                    return false;
                }

                let indx = this.geoitems.findIndex(geo => geo.options.geozoneId == geozoneLOptions.geozoneId)
                let geozone = null
                if (indx !== -1) {
                    geozone = this.geoitems[indx]
                    //if(!(_.isEqual(geozone.options, geozoneLOptions)))
                    if (JSON.stringify(geozone.options) !== JSON.stringify(geozoneLOptions)) {
                        //if(this.$isDevelopment) console.log('geozone.options was changed')
                        this.geoitemsLayer.removeLayer(geozone)//???
                        this.geoitems.splice(indx, 1)
                        indx = -1
                    }
                }
                if (indx === -1) {
                    if(!geozoneLOptions?.points?.filter(v => v)?.length) {
                        console.error('Geozone null points', geozoneLOptions)
                        return;
                    }
                    geozone = this.createGeoitem(geozoneLOptions)
                    if (!geozone) {
                        if (!geozoneLOptions?.name?.includes('SecurityShield')) {
                            console.error('Can\'t create Geoitem', geozoneLOptions)
                        }
                        return
                    }
                    // geozone.bindPopup(getGeozonePopupContent(geozoneLOptions), {noHide: true});
                    geozone.bindTooltip(geozoneLOptions.name, {
                        permanent: (true),
                        direction: 'bottom',
                        className: 'geozone-tooltip',
                        offset: [0, 0],
                    });
                    //geozone.on('click',function(e){this.geoitemsLayer.fire('click',e)});
                    this.geoitems.push(geozone)
                }
            })
            if (this.geoitemActiveId) {
                this.setGeoitemsVisible([this.geoitemActiveId])
            } else {
                this.setGeoitemsVisible(this.getGeoitemsOnMap)
            }
            //this.geoitems.push(...geoitems)
            //this.geoitemsLayer.addLayers(geoitems)
        },
        onReady() {
            this.geoitemsCluster = this.$refs.geoitemsCluster.leafletObject
            this.geoitemsLayer = this.$refs.geoitemsLayer.leafletObject
            //this.geoitemsLayer.addLayer(this.geoitemsCluster)
            this.debouncedUpdateGeozones()
        }
    },
    created() {
        this.debouncedUpdateGeozones = debounce(this.updateGeozones, 300)
        //this.debouncedUpdateGeozones()
    },
    mounted() {
        //this.debouncedUpdateGeozones()
        // new MarkerClusterGroup(this.geoitemsClusterOptions);
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
        // if(this.$isDevelopment) console.log('Geoitems l-layer-group update')
    },
}
</script>

<style scoped>

</style>